module.exports = __webpack_public_path__ + "img/leo.5b6a5d07.svg";